'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ProgressBar": "Polaris-ProgressBar",
  "sizeSmall": "Polaris-ProgressBar--sizeSmall",
  "sizeMedium": "Polaris-ProgressBar--sizeMedium",
  "sizeLarge": "Polaris-ProgressBar--sizeLarge",
  "toneHighlight": "Polaris-ProgressBar--toneHighlight",
  "tonePrimary": "Polaris-ProgressBar--tonePrimary",
  "toneSuccess": "Polaris-ProgressBar--toneSuccess",
  "toneCritical": "Polaris-ProgressBar--toneCritical",
  "Indicator": "Polaris-ProgressBar__Indicator",
  "IndicatorAppearActive": "Polaris-ProgressBar__IndicatorAppearActive",
  "IndicatorAppearDone": "Polaris-ProgressBar__IndicatorAppearDone",
  "Progress": "Polaris-ProgressBar__Progress",
  "Label": "Polaris-ProgressBar__Label"
};

exports.default = styles;
